import { createReducer } from 'typesafe-actions'
import { IBalance } from '@sparling/financial-common'
import { getBalancesRequest, getBalancesSuccess, getBalancesFailure, userBalanceUpdated } from '../actions'
import { ActionTypes } from '../types'
import { LoadingState } from '../../types'

export type BalancesState = {
  status: LoadingState
  data: IBalance[]
  error: Error | null
}

export const initialState: BalancesState = {
  status: 'IDLE',
  data: [],
  error: null,
}

export const balances = createReducer<BalancesState, ActionTypes>(initialState)
  .handleAction(getBalancesRequest, (state) => ({
    ...state,
    status: 'LOADING',
  }))
  .handleAction(getBalancesSuccess, (state, { payload }) => ({
    ...state,
    status: 'SUCCESS',
    data: payload,
  }))
  .handleAction(getBalancesFailure, (state, { payload }) => ({
    ...state,
    status: 'ERROR',
    error: payload,
  }))
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .handleAction(userBalanceUpdated, (state, { payload }) => {
    const existing = state.data.find((balance) => balance.asset === payload.asset)

    return {
      ...state,
      data: existing
        ? state.data.map((balance) =>
            balance.asset === payload.asset ? { ...balance, amount: payload.balance } : balance,
          )
        : [...state.data, { asset: payload.asset, amount: payload.balance }],
    }
  })
